/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Code_LengthInputs */

const fr_validation_code_length = /** @type {(inputs: Validation_Code_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un code de 60 caractères maximum.`)
};

const en_validation_code_length = /** @type {(inputs: Validation_Code_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a code of up to 60 characters.`)
};

/**
* | output |
* | --- |
* | "Enter a code of up to 60 characters." |
*
* @param {Validation_Code_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_code_length = /** @type {((inputs?: Validation_Code_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Code_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_code_length(inputs)
	return fr_validation_code_length(inputs)
});